import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'
import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

import {colorMetadata, fontMetadata} from '../../../../../../utils/builderMetadata'

export type TextStylesParams = {
  textBreadcrumbsFont: StyleParamType.Font
  textBreadcrumbsColor: StyleParamType.Color
  textListTitleFont: StyleParamType.Font
  textListTitleColor: StyleParamType.Color
  textExperienceNameFont: StyleParamType.Font
  textExperienceNameColor: StyleParamType.Color
  textExperienceSummaryFont: StyleParamType.Font
  textExperienceSummaryColor: StyleParamType.Color
  textExperienceDetailsFont: StyleParamType.Font
  textExperienceDetailsColor: StyleParamType.Color
}

export const textStylesParams = createStylesParams<TextStylesParams>({
  textBreadcrumbsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  textBreadcrumbsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textListTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Page-title', {
        htmlTag: 'h1',
        size: 32,
      })(params),
    metadata: fontMetadata('Page-title', 32),
  },
  textListTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
    metadata: colorMetadata(StyleType.color, 'color-title'),
  },
  textExperienceNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        htmlTag: 'h2',
        size: 24,
      })(params),
    metadata: fontMetadata('Body-M', 24),
  },
  textExperienceNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
    metadata: colorMetadata(StyleType.color, 'color-title'),
  },
  textExperienceSummaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  textExperienceSummaryColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textExperienceDetailsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  textExperienceDetailsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
})
